export const environment = {
  production: false,
  env: 'stg',
  version: 'stg-a645c701',
  feedbackDelay: 5000,
  api: 'https://stg.api.roz.copec.cl',
};
